export default __webpack_public_path__ + "static/media/section1_1.e848608a.png";